import { render, staticRenderFns } from "./pkgChange.vue?vue&type=template&id=315a99c2&scoped=true&"
import script from "./pkgChange.vue?vue&type=script&lang=js&"
export * from "./pkgChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a99c2",
  null
  
)

export default component.exports